export { default as Bookmarks } from './Bookmarks';
export { default as Display } from './Display';
export { default as EditProfile } from './EditProfile';
export { default as Gallery } from './Gallery';
export { default as Header } from './Header';
